import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { updateRemission } from '@/data/api/request/orderDetailsRequest';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpdateRemission() {
  const queryClient = useQueryClient();
  const { showSnackError, showSnackSuccess } = useSnackbarContext();

  const updateImageHook = useMutation({
    mutationFn: (args: { orderId: string; file: File }) =>
      updateRemission(args),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.detailOrder.deliveryInfo],
      });
      showSnackSuccess('Remision Guardada');
    },
    onError: () => showSnackError('Error al actualizar imagen'),
  });

  return {
    updateImage: updateImageHook.mutate,
  };
}
